import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { actions, selectors } from "../slices/systemMessageSlice";

const useSystemMessageState = (id: string, defaultIsOpen: boolean) => {
  "use memo";
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector((state) => selectors.getIsOpen(state, id, defaultIsOpen));

  const setIsOpen = (nextIsOpen: boolean) => {
    dispatch(actions.setOpen({ id, isOpen: nextIsOpen }));
  };

  return [isOpen, setIsOpen] as const;
};

export { useSystemMessageState };
